'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdGpsOff = function MdGpsOff(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm27.1 29.2l-16.3-16.3q-2.4 3.2-2.4 7.1 0 4.8 3.4 8.2t8.2 3.4q3.9 0 7.1-2.4z m-22.1-22.1l2.1-2.1 27.9 27.9-2.1 2.1-3.4-3.4q-3.6 2.9-7.9 3.3v3.5h-3.2v-3.5q-5.3-0.5-9-4.3t-4.3-9h-3.5v-3.2h3.5q0.4-4.3 3.3-7.9z m29.9 11.3h3.5v3.2h-3.5q-0.4 3.1-1.6 5.4l-2.5-2.5q0.8-2.2 0.8-4.5 0-4.8-3.4-8.2t-8.2-3.4q-2.3 0-4.4 0.8l-2.5-2.5q2.4-1.2 5.3-1.6v-3.5h3.2v3.5q5.3 0.5 9 4.3t4.3 9z' })
        )
    );
};

exports.default = MdGpsOff;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/gps-off.js
// module id = 2396
// module chunks = 0